<dialog #asideModalDialog class="dialog">
  <ng-content></ng-content>
</dialog>
